export default __webpack_public_path__ + "static/media/semaphore.20a09de8.svg";